<script>
    import {
        Modal
    } from "carbon-components-svelte";

    export let open;
    export let confirmObj;
</script>

<Modal
    class="confirm-modal"
    size="xs"
    bind:open={open}
    modalHeading={confirmObj?.title}
    primaryButtonText="확인"
    secondaryButtonText="취소"
    on:click:button--secondary={() => (open = false)}
    on:open
    on:close
    on:submit={confirmObj?.submit}
>
<style>
    .confirm-modal > .bx--modal-container {
       width:350px;
    }
</style>
    <p>{confirmObj?.msg}</p>
</Modal>
